// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"y_sX d_gw d_b8 d_cc d_cn d_br d_bQ","menuItemSub":"y_sY d_by d_b8 d_cn","menuMainLink":"y_sZ d_gx d_d9","menuLink":"y_s0 d_gx d_d9","Link":"y_nP f_nP f_m4 f_np"};